import { useRoutes } from '@/shared/routes';

const names = [
  {
    id: useRoutes.EPK_ITEM_NAME,
    name: 'Книга',
    key: 'code',
    symbol: '№',
  },
  {
    id: useRoutes.ACCOUNT_ITEM_NAME,
    name: 'Лицевой счет',
    key: 'dim_personal_account',
    symbol: '№',
  },
  {
    id: useRoutes.HEAD_ITEM_NAME,
    name: 'Глава ЛПХ',
    key: 'dim_fio',
    symbol: '',
  },
  {
    id: useRoutes.LPH_ITEM_NAME,
    name: 'Карточка ЛПХ',
    key: 'lph',
    symbol: '№',
  },
  {
    id: useRoutes.EPK_REPORT_ITEM_NAME,
    name: 'Сводная похозяйственная книга',
    key: 'POINT_code_front',
    symbol: '№',
  },
  {
    id: useRoutes.EXTRACT_ITEM_NAME,
    name: 'Выписка',
    key: 'pointCode',
    symbol: '№',
  },
];

const namesMap = new Map<keyof IRelated, string>([
  ['accounts', 'Лицевой счет'],
  ['docs_lph', 'Карточка ЛПХ'],
  ['heads_lph', 'Карточка главы ЛПХ'],
  ['svod_five_years', 'Свод за 5 лет'],
]);

export interface IRelated {
  accounts: string[]; // лс
  docs_lph: number[]; // карточка
  heads_lph: number[]; // глава
  svod_five_years: number[]; // 5 летний свод

  // TODO Понять откуда это взято
  // req_delete_mark?: boolean;
  // scan_is_empty?: boolean;
  // time_stamp?: string;
  // user?: string;
  // user_fio?: string;
  // year_end?: string;
  // year_start?: string;
}

export interface IName {
  id: string;
  title: string;
  subtitle: string | number;
  second?: { title: string; subtitle: string };
  category: string;
}

export interface IModalDelete {
  title: string;
  subtitle: string;
  countRelated: number;
  related?: { title: string; subtitle: string[] | number[] }[] | any;
}

export const getModalRelated = async (
  item: any,
  id: string | undefined,
  pointCode: string | number | bigint,
  apiService: any
): Promise<IModalDelete> => {
  const modalDelete = {
    countRelated: 0,
    related: [],
  } as IModalDelete;

  const pointCodeValue = id === useRoutes.LPH_ITEM_NAME ? item.epk : pointCode;

  const nameObj = names.find(i => i.id === id);
  if (nameObj) {
    modalDelete.title =
      nameObj.name + ' ' + nameObj.symbol + String(item[nameObj.key]);
  }

  if (
    !id ||
    [
      useRoutes.LPH_ITEM_NAME,
      useRoutes.EPK_REPORT_ITEM_NAME,
      useRoutes.EXTRACT_ITEM_NAME,
    ].includes(id)
  ) {
    return modalDelete;
  }

  const r = await apiService.getRelated(pointCodeValue);

  const related = r?.response?.related as IRelated | undefined;
  if (!related) return modalDelete;

  const _relatedPush = (title: string, subtitle: string[] | number[]) => {
    modalDelete.related.push({ title, subtitle });
    modalDelete.countRelated += subtitle.length;
  };

  for (const [key, name] of namesMap) {
    const val = related[key];
    if (val?.length) _relatedPush(name, val);
  }

  return modalDelete;
};
